export const formatPrice = (val: string | number, unit = true) => {
  const num: number = +val || 0;
  return (
    (unit ? 'THB ' : '') +
    num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  );
};
export const formatNumber = (val: string, decimal = 0) => {
  return Number(val) === 0 ? '-' : Number(val).toFixed(decimal);
};

export const stripHtmlTags = (str: string = '') => {
  return str.replace(/<[^>]*>/g, '');
};
